export const environment = {
  production: false,
  apiURL: 'https://nightly.cms.btv-intern.de/api/v1',
  serverURL: 'https://nightly.cms.btv-intern.de',
  watermark: 'SyBi Testumgebung nigthly',
  ssePath: '/bridge',
};
